/*
 * Project: BookingEngine
 * Module: components/booking/rooms/RoomList.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// import CustomizedRoomSolution from './CustomizedRoomSolution';
// import RoomsBestValue from './RoomsBestValue';
import RoomTile from './RoomTile';

import { DEVICES, setMultipleRoomStep, setShowSomeRoomsNotAvailableOnNewDates } from '../../../actions/Booking';
import { addSelectedRoomsToCart, selectBestRateEvents, setCartUpdating } from '../../../actions/Cart';
import { setOpenReservationDetails } from '../../../actions/Session';
import { combinableRooms, getCheapestCombination } from '../../../utils/Room';
import { MULTIPLE_ROOMS } from '../../../constants';
import withNavigate from '../../../withNavigate'; // Importa el HOC

class RoomListTwoRooms extends React.Component {
  constructor(props) {
    super(props);

    const cheapestCombination = getCheapestCombination(props.hotel, props.currency.code);
    const roomCombinations = combinableRooms(props.hotel);
    this.state = {
      cheapestCombination,
      roomCombinations,
      addingButtonId: null,
      showBestRate: true,
      showCustomAndList: !props.isMobile,
      showLoading: false,
    };

    // Declaramos la variable para almacenar los callbacks
    this.roomTileCallbacksMap = {}; // en constructor

    this.onSelectBestValue = this.onSelectBestValue.bind(this);
    this.onToggleCustom = this.onToggleCustom.bind(this);
    this.onSelectCustom = this.onSelectCustom.bind(this);
  }

  isCurrentRoomIncludedInRoomsToEdit(room, roomsToEdit) {
    const foundItem = roomsToEdit.find((item) => item.room_code === room.code
             && room.rates.some((rate) => rate.code === item.rate_code)
              && item.order + 1 === room.roomNumber); // Con ésto nos aseguramos sólo de procesar el cuarto de ese stepIndex
    return {
      isIncluded: !!foundItem, // Convierte a booleano (true si existe, false si no)
      rate_code: foundItem?.rate_code || null, // Devuelve el rate_code o null si no hay coincidencia
      board_code: foundItem?.board_code || null,
      order: foundItem?.order || 0,
    };
  }

  findRateByCode(room, rateCode) {
    return room.rates.find((rate) => rate.code === rateCode);
  }

  async componentDidMount() {
    if (this.props.isEditingBooking) {
      setTimeout(async () => { // Pequeño delay para asegurar que el hijo esté montado
        this.props.dispatch(setCartUpdating(true));
        for (let i = 1; i <= this.props.distributions.length; i++) {
          // En este caso necesitamos que las iteraciones se ejecuten en serie, porque es posible ejecutarlas en paralelo
          // lo cual evita usar await dentro de un for, pero en este caso sí necesitamos que se ejecuten
          // eslint-disable-next-line no-await-in-loop
          await this.processRooms(i);
        }
        this.props.dispatch(setCartUpdating(false));
        //En caso de que haya cuartos que fueron reservados, pero al editar la booking, y cambiar fechas o algo así y ya no estén disponibles
        //Quedan como null en this.props.multipleRoomSelection en el índice que correspondan, entonces los demás cuartos se seleccionan
        //y al final se debe setear el multipleRoomStep en el primer cuarto que esté en null para que el usuario pueda elegir otro cuarto
        const firstValidRoomKey = ['1', '2', '3', '4'].find((key) => this.props.multipleRoomSelection[key] === null);
        const numberFirstValidRoomKey = Number(firstValidRoomKey);
        if (numberFirstValidRoomKey <= this.props.distributions.length) {
          this.props.dispatch(setMultipleRoomStep(firstValidRoomKey));
        }
        if (this.props.isMobile) {
          this.props.dispatch(setOpenReservationDetails(true));
        }
        // Acá debemos mostrar el pop up para indicar si hubo cuartos que no tienen disponibilidad
        this.props.dispatch(setShowSomeRoomsNotAvailableOnNewDates(this.showPopUpSomeRoomsNotAvailable()));
      }, 1000);
    }
  }

  showPopUpSomeRoomsNotAvailable() {
    const cartRooms = this.props.cartHotel.rooms;
    let showPopUp = false;
    for (let i = 0; i < cartRooms.length; i++) {
      if (!this.roomExistsInMultipleRoomSelection(cartRooms[i].room.code, cartRooms[i].distribution)) {
        showPopUp = true;
      }
    }
    return showPopUp;
  }

  roomExistsInMultipleRoomSelection(roomCode, distribution) {
    for (let i = 1; i <= 4; i++) {
      if (this.props.multipleRoomSelection[i.toString()] != null) {
        if (this.props.multipleRoomSelection[i.toString()].room.code === roomCode
          && this.areDistributionsEqual(this.props.multipleRoomSelection[i.toString()].room.distribution,
            distribution)) {
          return true;
        }
      }
    }
    return false;
  }

  areDistributionsEqual(dist1, dist2) {
    return dist1.adults === dist2.adults
           && dist1.children === dist2.children
           && dist1.infants === dist2.infants;
  }

  async processRooms(stepIndex) {
    this.setState({ showLoading: true });
    // 1. Mapear los códigos y posiciones (roomNumber) del carrito
    const cartRooms = this.props.cartHotel.rooms;
    const allRooms = this.props.hotel.rooms[stepIndex];
    const availableRoomsMap = new Map(allRooms.map((room) => [room.code, room]));
    // 2. Construir orderedRooms con isMissing y roomNumber
    const orderedRooms = cartRooms.map((cartRoom, index) => {
      const roomCode = cartRoom.room.code;
      const availableRoom = availableRoomsMap.get(roomCode);

      if (availableRoom /*&& this.areDistributionsEqual(cartRoom.distribution, availableRoom.distribution)*/) {
        return {
          ...availableRoom,
          isMissing: false,
          roomNumber: index + 1, // +1 si prefieres que empiece en 1
        };
      }
      return {
        ...cartRoom.room,
        isMissing: true,
        roomNumber: index + 1,
      };
    });

    // 3. Procesar las habitaciones
    let roomPlaced = false;

    /*for (const room of orderedRooms) {
      if (room.isMissing === false) {
        roomItemPlaced = this.processRoom(room);
        if (roomItemPlaced) {
          roomPlaced = true;
        }
        await new Promise((resolve) => setTimeout(resolve, 2000));
      }
    }*/
    // Eso de arriba es más simple pero el linter pide no usar for of porque dice que para navegadores
    // antigüos es muy pesado porque se debeusar regenerator-runtime: iterators/generators require
    // regenerator-runtime, which is too heavyweight for this guide to allow them. Separately, loops
    // should be avoided in favor of array iterations
    await orderedRooms.reduce(async (prevPromise, room) => {
      await prevPromise;
      if (room.isMissing === false && room.roomNumber === stepIndex) {
        const roomItemPlaced = this.processRoom(room);
        if (roomItemPlaced) {
          roomPlaced = true;
        }
        await new Promise((resolve) => {
          setTimeout(resolve, 2000); // Sin return
        });
      }
    }, Promise.resolve());

    if (roomPlaced === false) {
      const nextRoomToBeSelected = Number(this.props.multipleRoomStep) + 1;
      if (nextRoomToBeSelected <= this.props.distributions.length) {
        this.props.dispatch(setMultipleRoomStep(nextRoomToBeSelected.toString()));
        await new Promise((resolve) => {
          setTimeout(resolve, 2000); // Sin return
        });
      }
    }

    this.setState({ showLoading: false });
    // 4. Opcional: Habitaciones faltantes
    //const missingCartHotelRooms = orderedRooms.filter(room => room.isMissing);
    //return { orderedRooms, missingCartHotelRooms };
  }

  processRoom(room) {
    let roomPlaced = false;
    const roomsToEdit = this.props.cartHotel?.rooms?.map((roomItem) => ({
      room_code: roomItem.room.code,
      rate_code: roomItem.rate.code,
      order: roomItem.order,
      board_code: roomItem.board.code,
    })) || [];
    if (room.isMissing) {
      /*const nextRoomToBeSelected = room.roomNumber+1;
      if (nextRoomToBeSelected <= this.props.distributions.length) {
        this.props.dispatch(setMultipleRoomStep(nextRoomToBeSelected.toString()));
      }*/
    } else {
      const roomToEditInludedObject = this.isCurrentRoomIncludedInRoomsToEdit(room, roomsToEdit);
      const roomAlreadyPlaced = this.cartRoomAlreadyInMultipleRoomSelection(roomToEditInludedObject.order + 1,
        room.code,
        roomToEditInludedObject.rate_code,
        roomToEditInludedObject.board_code);

      if (roomToEditInludedObject.isIncluded && roomAlreadyPlaced === false) {
        const selectedRate = this.findRateByCode(room, roomToEditInludedObject.rate_code);
        //Llamar a las siguientes dos funciones del componente hijo:
        //onRateSelect(selectedRate);
        //onSelectRoom(this.props.room);
        // Llamamos a los callbacks si existen
        const callbacks = this.roomTileCallbacksMap[room.code];
        if (callbacks) {
          callbacks.onRateSelect(selectedRate);
          callbacks.onSelectRoom(room, this.props.multipleRoomStep, selectedRate);
          roomPlaced = true;
        }
      }
    }
    return roomPlaced;
  }

  cartRoomAlreadyInMultipleRoomSelection(roomNumber, room_code, rate_code, board_code) {
    // Acá falta considerar boardCode
    //console.log('room_code: ' + room_code + ", rate_code: " + rate_code + ", board_code: " + board_code);
    if (this.props.multipleRoomSelection[roomNumber.toString()] == null) {
      return false;
    }
    return this.props.multipleRoomSelection[roomNumber.toString()].room.code === room_code
    && this.props.multipleRoomSelection[roomNumber.toString()].rateCode === rate_code
    && this.props.multipleRoomSelection[roomNumber.toString()].boardCode === board_code;
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    if (this.props.currency.code !== nextProps.currency.code) {
      // We want to recalculate the bestPrice amount in the new currency
      const cheapestCombination = getCheapestCombination(nextProps.hotel, nextProps.currency.code);
      this.setState({ cheapestCombination });
    }
  }

  onToggleCustom() {
    this.setState({ showBestRate: false, showCustomAndList: true });
  }

  onSelectCustom() {
    const selection = this.props.multipleRoomSelection;
    this.onCompleteRoomSelection(selection, this.getCustomRoomSelection.bind(this));
    this.setState({ addingButtonId: 'customSolution' });
  }

  onSelectBestValue() {
    const bestValueComb = this.state.cheapestCombination;
    this.onCompleteRoomSelection(bestValueComb, this.getBestRoomSelection.bind(this));
    this.props.dispatch(selectBestRateEvents(bestValueComb));
    this.setState({ addingButtonId: 'bestRate' });
  }

  onCompleteRoomSelection(combinationObj, roomMapper) {
    let selectedRooms = [
      roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
    ];
    if (combinationObj) {
      if (combinationObj.bestRoomCodes) {
        if (combinationObj.bestRoomCodes[4]) {
          selectedRooms = [
            roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
            roomMapper(combinationObj, MULTIPLE_ROOMS.SECOND),
            roomMapper(combinationObj, MULTIPLE_ROOMS.THIRD),
            roomMapper(combinationObj, MULTIPLE_ROOMS.FOURTH),
          ];
        } else if (combinationObj.bestRoomCodes[3]) {
          selectedRooms = [
            roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
            roomMapper(combinationObj, MULTIPLE_ROOMS.SECOND),
            roomMapper(combinationObj, MULTIPLE_ROOMS.THIRD),
          ];
        } else if (combinationObj.bestRoomCodes[2]) {
          selectedRooms = [
            roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
            roomMapper(combinationObj, MULTIPLE_ROOMS.SECOND),
          ];
        } else if (combinationObj.bestRoomCodes[1]) {
          selectedRooms = [
            roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
          ];
        }
      } else if (combinationObj[4]) {
        selectedRooms = [
          roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
          roomMapper(combinationObj, MULTIPLE_ROOMS.SECOND),
          roomMapper(combinationObj, MULTIPLE_ROOMS.THIRD),
          roomMapper(combinationObj, MULTIPLE_ROOMS.FOURTH),
        ];
      } else if (combinationObj[3]) {
        selectedRooms = [
          roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
          roomMapper(combinationObj, MULTIPLE_ROOMS.SECOND),
          roomMapper(combinationObj, MULTIPLE_ROOMS.THIRD),
        ];
      } else if (combinationObj[2]) {
        selectedRooms = [
          roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
          roomMapper(combinationObj, MULTIPLE_ROOMS.SECOND),
        ];
      } else if (combinationObj[1]) {
        selectedRooms = [
          roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
        ];
      }
      this.props.dispatch(addSelectedRoomsToCart(selectedRooms, this.props.navigate));
    }
  }

  getAvailId() {
    // The availId is set on the boards but is the same for all boards from last availability
    const board = this.props.hotel.rooms[MULTIPLE_ROOMS.FIRST][0].rates[0].boards[0];
    return board.avail_id;
  }

  getUseRequested(roomId) {
    const room = this.props.hotel.rooms && this.props.hotel.rooms[roomId] ? this.props.hotel.rooms[roomId][0] : null;
    return room ? room.use_requested : null;
  }

  getBestRoomSelection(bestValueComb, roomId) {
    const roomCode = bestValueComb.bestRoomCodes[roomId];
    return {
      roomId,
      roomCode,
      rateCode: bestValueComb.rateCode,
      boardCode: bestValueComb.boardCode,
      availId: this.getAvailId(),
      use: this.getUseRequested(roomId),
    };
  }

  getCustomRoomSelection(customComb, roomId) {
    const selection = customComb[roomId];
    const { room } = selection;
    return {
      roomId,
      roomCode: room.code,
      rateCode: selection.rateCode,
      boardCode: selection.boardCode,
      availId: customComb.availId,
      use: room.use_requested,
    };
  }

  mergeAllowedBoards(boards1, boards2) {
    const boards2Set = new Set(boards2);
    return boards1.filter((boardCode) => boards2Set.has(boardCode));
  }

  getCombiningData(room) {
    // We check on RoomCombinations that for the current distribution, the current room has combining rates / boards
    const validCombinations = this.state.roomCombinations[this.props.multipleRoomStep] || {};
    if (!validCombinations || !validCombinations[room.code]) {
      return null;
    }
    // For the first room, we just want to return its own restrictions
    if (`${room.request_id}` === MULTIPLE_ROOMS.FIRST) {
      return validCombinations[room.code];
    }

    // In case of room 2, we need to do extra work:
    if (`${room.request_id}` === MULTIPLE_ROOMS.SECOND) {
      // - we know all rates for Room1 are also valid for Room2, as they have been already filtered out
      // - however, we need to filter the boards for Room2 according to the selected rate for Room1
      const room1Combinations = this.state.roomCombinations[MULTIPLE_ROOMS.FIRST] || {};

      // If the selection is cleared (by reloading the page), then Room2 should not be displayed
      const room1Selection = this.props.multipleRoomSelection[MULTIPLE_ROOMS.FIRST];
      if (!room1Selection) {
        return null;
      }

      const selectedRoom1Code = room1Selection.room.code;
      // If this room is the same type that for Room1, we make sure there is at least 2 units of both
      const hasEnoughQuota = selectedRoom1Code === room.code ? room.quota > 1 : true;
      if (!hasEnoughQuota) {
        return null;
      }

      const room2Combinations = {}; // a new object to avoid overwriting the original data
      let hasCombinations = false;
      Object.keys(room1Combinations[selectedRoom1Code]).forEach((rateCode) => {
        const currentCombinations = validCombinations[room.code][rateCode];
        // We must make sure that there is at least one rate in common between the selected for Room1 and this Room
        if (currentCombinations) {
          const validBoardCodes1 = room1Combinations[selectedRoom1Code][rateCode].validBoardCodes;
          const validBoardCodes2 = currentCombinations.validBoardCodes;
          const combinedValidBoards = this.mergeAllowedBoards(validBoardCodes1, validBoardCodes2);

          // We also need to make sure that the selected board for Room1 is available in Room2
          const selectedBoardCode = room1Selection.boardCode;
          const hasValidBoards = combinedValidBoards.indexOf(selectedBoardCode) !== -1;
          if (hasValidBoards) {
            hasCombinations = true;
            room2Combinations[rateCode] = {
              validBoardCodes: combinedValidBoards,
              validRoomCodes: validCombinations[room.code][rateCode].validRoomCodes,
            };
          }
        }
      });
      return hasCombinations ? room2Combinations : null;
    }

    // In case of room 3, we need to do extra work:
    if (`${room.request_id}` === MULTIPLE_ROOMS.THIRD) {
      // - we know all rates for Room1 are also valid for Room2, as they have been already filtered out
      // - however, we need to filter the boards for Room2 according to the selected rate for Room1
      const room1Combinations = this.state.roomCombinations[MULTIPLE_ROOMS.FIRST] || {};

      // If the selection is cleared (by reloading the page), then Room2 should not be displayed
      const room1Selection = this.props.multipleRoomSelection[MULTIPLE_ROOMS.FIRST];
      const room2Selection = this.props.multipleRoomSelection[MULTIPLE_ROOMS.SECOND];
      if (!room1Selection || !room2Selection) {
        return null;
      }

      const selectedRoom1Code = room1Selection.room.code;
      const selectedRoom2Code = room2Selection.room.code;
      let hasEnoughQuota;
      if (room.code === selectedRoom1Code) {
        if (room.code === selectedRoom2Code) {
          hasEnoughQuota = room.quota > 2;
        } else {
          hasEnoughQuota = room.quota > 1;
        }
      } else if (room.code === selectedRoom2Code) {
        hasEnoughQuota = room.quota > 1;
      } else {
        hasEnoughQuota = true;
      }
      if (!hasEnoughQuota) {
        return null;
      }

      const room3Combinations = {}; // a new object to avoid overwriting the original data
      let hasCombinations = false;
      Object.keys(room1Combinations[selectedRoom1Code]).forEach((rateCode) => {
        const currentCombinations = validCombinations[room.code][rateCode];
        // We must make sure that there is at least one rate in common between the selected for Room1 and this Room
        if (currentCombinations) {
          const validBoardCodes1 = room1Combinations[selectedRoom1Code][rateCode].validBoardCodes;
          const validBoardCodes2 = currentCombinations.validBoardCodes;
          const combinedValidBoards = this.mergeAllowedBoards(validBoardCodes1, validBoardCodes2);

          // We also need to make sure that the selected board for Room1 is available in Room2
          const selectedBoardCode = room1Selection.boardCode;
          const hasValidBoards = combinedValidBoards.indexOf(selectedBoardCode) !== -1;
          if (hasValidBoards) {
            hasCombinations = true;
            room3Combinations[rateCode] = {
              validBoardCodes: combinedValidBoards,
              validRoomCodes: validCombinations[room.code][rateCode].validRoomCodes,
            };
          }
        }
      });
      return hasCombinations ? room3Combinations : null;
    }

    // In case of room 4, we need to do extra work:
    if (`${room.request_id}` === MULTIPLE_ROOMS.FOURTH) {
      // - we know all rates for Room1 are also valid for Room2, as they have been already filtered out
      // - however, we need to filter the boards for Room2 according to the selected rate for Room1
      const room1Combinations = this.state.roomCombinations[MULTIPLE_ROOMS.FIRST] || {};

      // If the selection is cleared (by reloading the page), then Room2 should not be displayed
      const room1Selection = this.props.multipleRoomSelection[MULTIPLE_ROOMS.FIRST];
      const room2Selection = this.props.multipleRoomSelection[MULTIPLE_ROOMS.SECOND];
      const room3Selection = this.props.multipleRoomSelection[MULTIPLE_ROOMS.THIRD];
      if (!room1Selection || !room2Selection || !room3Selection) {
        return null;
      }

      const selectedRoom1Code = room1Selection.room.code;
      const selectedRoom2Code = room2Selection.room.code;
      const selectedRoom3Code = room3Selection.room.code;
      let hasEnoughQuota;
      if (room.code === selectedRoom1Code) {
        if (room.code === selectedRoom2Code) {
          if (room.code === selectedRoom3Code) {
            hasEnoughQuota = room.quota > 3;
          } else {
            hasEnoughQuota = room.quota > 2;
          }
        } else if (room.code === selectedRoom3Code) {
          hasEnoughQuota = room.quota > 2;
        } else {
          hasEnoughQuota = room.quota > 1;
        }
      } else if (room.code === selectedRoom2Code) {
        if (room.code === selectedRoom3Code) {
          hasEnoughQuota = room.quota > 2;
        } else {
          hasEnoughQuota = room.quota > 1;
        }
      } else if (room.code === selectedRoom3Code) {
        hasEnoughQuota = room.quota > 1;
      } else {
        hasEnoughQuota = true;
      }
      if (!hasEnoughQuota) {
        return null;
      }

      const room3Combinations = {}; // a new object to avoid overwriting the original data
      let hasCombinations = false;
      Object.keys(room1Combinations[selectedRoom1Code]).forEach((rateCode) => {
        const currentCombinations = validCombinations[room.code][rateCode];
        // We must make sure that there is at least one rate in common between the selected for Room1 and this Room
        if (currentCombinations) {
          const validBoardCodes1 = room1Combinations[selectedRoom1Code][rateCode].validBoardCodes;
          const validBoardCodes2 = currentCombinations.validBoardCodes;
          const combinedValidBoards = this.mergeAllowedBoards(validBoardCodes1, validBoardCodes2);

          // We also need to make sure that the selected board for Room1 is available in Room2
          const selectedBoardCode = room1Selection.boardCode;
          const hasValidBoards = combinedValidBoards.indexOf(selectedBoardCode) !== -1;
          if (hasValidBoards) {
            hasCombinations = true;
            room3Combinations[rateCode] = {
              validBoardCodes: combinedValidBoards,
              validRoomCodes: validCombinations[room.code][rateCode].validRoomCodes,
            };
          }
        }
      });
      return hasCombinations ? room3Combinations : null;
    }
    return null;
  }

  renderRoomTile(room, num) {
    // Si en la distribución sólo hay un cuarto
    // no importa eso de roomCombineData
    if (this.props.distributions.length === 1) {
      return (
        <RoomTile
                key={`${room.request_id}_${room.code}`}
                room={room}
                position={num}
                hotel={this.props.hotel}
                onShowRoomDetails={this.props.onToggleRoomDetails}
                // Nuevas props para los callbacks
                registerCallbacks={(callbacks) => {
                  this.roomTileCallbacksMap[room.code] = callbacks;
                }}
        />
      );
    }

    // This room has no combination for the other room distribution, so it should not be shown
    const roomCombineData = this.getCombiningData(room);
    if (!roomCombineData) {
      return null;
    }

    return (
            <RoomTile
                    key={`${room.request_id}_${room.code}`}
                    room={room}
                    position={num}
                    hotel={this.props.hotel}
                    combiningData={roomCombineData}
                    onShowRoomDetails={this.props.onToggleRoomDetails}
                    // Nuevas props para los callbacks
                    registerCallbacks={(callbacks) => {
                      this.roomTileCallbacksMap[room.code] = callbacks;
                    }}
            />
    );
  }

  renderLoading() {
    return (
      <div className="row">
        <div className="col-md-12 col-sm-12" style={{
          justifyItems: 'center',
          marginTop: '20px',
        }}>
          <img src="/img/loading5.gif"/>
          <p style={{ fontWeight: 'bold', fontSize: '16px' }}>{this.context.t('Loading your selected rooms...')}</p>
        </div>
      </div>
    );
  }

  render() {
    /*const {
      addingButtonId, showBestRate, showCustomAndList, cheapestCombination, roomCombinations,
    } = this.state;*/
    /*const {
      hotel, isCartUpdating, currency, lang, isMobile, rooms,
    } = this.props;*/
    const {
      rooms,
    } = this.props;
    return (
            <>
              {this.state.showLoading && this.renderLoading()}
              <div className="RoomListTwoRooms"
                style={{ display: this.state.showLoading === false ? 'block' : 'none' }}>
                {/*
                <RoomsBestValue
                        hotel={hotel}
                        bestRate={cheapestCombination}
                        isVisible={showBestRate}
                        isAdding={isCartUpdating}
                        isAddingSelf={addingButtonId === 'bestRate'}
                        currency={currency}
                        onSelect={this.onSelectBestValue}
                        lang={lang}/>
                <CustomizedRoomSolution isMobile={isMobile}
                                        isVisible={showCustomAndList}
                                        isAdding={isCartUpdating}
                                        isAddingSelf={addingButtonId === 'customSolution'}
                                        onToggleCustom={this.onToggleCustom}
                                        onSelectCustom={this.onSelectCustom}
                                        combiningData={roomCombinations}/>*/}
                {/* "TwoRoomScroll" div is required by "CustomizedRoomSolution" to determine the scrolling position */}
                <div className={'TwoRoomScroll room-card-list'}>
                  {/*this.props.selectRoomTitleText !== ''
                    && <h2 className="select-room-title">{this.props.selectRoomTitleText}</h2>*/}
                  {rooms.map((room, num) => this.renderRoomTile(room, num))}
                </div>
              </div>
            </>
    );
  }
}

RoomListTwoRooms.propTypes = {
  hotel: PropTypes.object.isRequired,
  rooms: PropTypes.array.isRequired,
  currency: PropTypes.object.isRequired,
  onToggleRoomDetails: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

RoomListTwoRooms.contextTypes = {
  t: PropTypes.func.isRequired,
};

// Conectar el componente con Redux
const mapStateToProps = (state) => ({
  multipleRoomSelection: state.booking.multipleRoomSelection,
  multipleRoomStep: state.booking.multipleRoomStep,
  isMobile: state.booking.device === DEVICES.MOBILE,
  isCartUpdating: state.cart.isUpdating,
  lang: state.i18nState.lang,
  isEditingBooking: state.booking.isEditingBooking,
  cartHotel: state.cart.cartHotel,
  distributions: state.bookingFormState.distributions,
});

const ConnectedRoomListTwoRooms = connect(mapStateToProps)(RoomListTwoRooms);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedRoomListTwoRooms);
